// Split plain text into text and link segments (http/https only) for plain-text email bodies.

export type Segment =
  { type: "text"; value: string } | { type: "link"; value: string; href: string };

const URL_RE = /\bhttps?:\/\/[^\s<>"']+/gi;
const TRAILING = /[.,;:!?'"]+$/;

function trimUrl(raw: string): string {
  let url = raw.replace(TRAILING, "");
  // Drop an unbalanced closing bracket, e.g. "(see https://x.y/z)".
  for (const [open, close] of [
    ["(", ")"],
    ["[", "]"],
    ["{", "}"],
  ] as const) {
    while (url.endsWith(close) && url.split(open).length < url.split(close).length) {
      url = url.slice(0, -1).replace(TRAILING, "");
    }
  }
  return url;
}

export function linkify(text: string): Segment[] {
  const out: Segment[] = [];
  let cursor = 0;
  for (const match of text.matchAll(URL_RE)) {
    const start = match.index ?? 0;
    const url = trimUrl(match[0]);
    if (!url) continue;
    if (start > cursor) out.push({ type: "text", value: text.slice(cursor, start) });
    out.push({ type: "link", value: url, href: url });
    cursor = start + url.length;
  }
  if (cursor < text.length) out.push({ type: "text", value: text.slice(cursor) });
  return out;
}
